mutation CopyEmoteWallToEvent($eventId: ID!, $fromEmoteWallId: ID!, $fromEventId: ID, $channels: String!) {
  wall: StreamToolsCopyEmoteWallToEvent(eventId: $eventId, fromEmoteWallId: $fromEmoteWallId, fromEventId: $fromEventId, channels: $channels) {
    emoteWallId
    eventId
    name
    twitchChatChannels
    style
    emoteSize
    density
    durationSeconds
    showTwitchEmotes
    show7tvEmotes
    showBttvEmotes
    showFfzEmotes
    youtubeChatChannels
    blockedWords
    createdAt
  }
}
